import { render, staticRenderFns } from "./FileModalAttach.vue?vue&type=template&id=ddb1c4a4&scoped=true"
import script from "./FileModalAttach.vue?vue&type=script&lang=js"
export * from "./FileModalAttach.vue?vue&type=script&lang=js"
import style0 from "./FileModalAttach.vue?vue&type=style&index=0&id=ddb1c4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb1c4a4",
  null
  
)

export default component.exports